<template>
  <div class="prepare-for-credentials">
    <div class="description">
      <div class="title">לשלב הבא צריך להכין את פרטי ההתחברות לאתר הבנק והאשראי. כוס קפה והתזרים שלך מוכן!</div>
      <div class="subtitle">בעזרת פרטי ההתחברות המערכת תיגש לחשבונות שלך ותבנה לך תיכף תזרים מדויק</div>
      <div class="image-wrapper">
        <img class="coffee-cup" :src="require('@/assets/onboarding/creds-coffee-cup.svg')">
      </div>
    </div>
    <div class="information-accordion">
      <div class="expandable-question">
        <div  v-for="(text, index) in qnaContent" :key="index">
          <expandable-summary-row  text-style="medium"
                                   :with-shadow=false
                                   :is-expandable=true
                                   :header-text="text.question"
                                    @expanded="() => sendEvent(text.type)">
            <template v-slot:content>
              <div class="answer">
                {{ text.answer }}
              </div>
            </template>
          </expandable-summary-row>
          <separator></separator>
        </div>
      </div>
      <div class="footer-info">אפשר לחזור לתהליך הרישום מהלינק שקיבלת<span class="word"> ב-Whatsapp</span>  בכל שלב ולהמשיך מאיפה שעצרת</div>
    </div>
    <div class="footer">
      <single-click-button class="riseup-button" :size="'small'" title="לחיבור החשבונות" :action="confirm"/>
    </div>
  </div>
</template>

<script>
import SingleClickButton from '@/base-components/SingleClickButton';
import Segment from '@/Segment';
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import ExpandableSummaryRow
  from '../../../navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ExpandableSummaryRow';

const qnaContent = [
  {
    question: 'מה אם יש לי יותר מחשבון בנק אחד?',
    answer: 'אין בעיה, אפשר לחבר כמה חשבונות שרוצים ורייזאפ תייצר לך תזרים אחד מכולם.',
    type: 'multiple_banks',
  },
  {
    question: 'מה אם יש לי כמה כרטיסי אשראי?',
    answer: 'אין בעיה, אפשר לחבר כמה כרטיסי אשראי שרוצים ורייזאפ תייצר לך תזרים אחד מכולם.',
    type: 'multiple_credits',
  },
  {
    question: 'מה אם אנחנו זוג בלי חשבון בנק משותף?',
    // eslint-disable-next-line max-len
    answer: 'תוכלו לחבר את שני החשבונות והמערכת תייצר לכם תזרים אחד מכל החשבונות. זה יכול להיות פתרון מצוין להתנהל ביחד כלכלית בלי חשבון בנק משותף.',
    type: 'couple_different_banks',
  },
];

export default {
  name: 'PrepareCredentials',
  components: {
    ExpandableSummaryRow,
    SingleClickButton,
    Separator: BaseUI.Separator,
  },
  async created() {
    Segment.trackUserGot('PrepareCredentials_PageEntered');
  },
  computed: {
    qnaContent() {
      return qnaContent;
    },
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    confirm() {
      Segment.trackUserInteraction('PrepareCredentials_NextClicked');
      this.onboardingPageSubmit();
    },
    sendEvent(type) {
      Segment.trackUserInteraction('PrepareCredentials_ExpandedBullet', { type });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

.prepare-for-credentials {

  .description {
    background-color: $riseup_light_red;
    padding: 40px 30px 27px;

    .title {
      font-size: 24px;
      line-height: 32px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .subtitle {
      font-size: 18px;
      line-height: 24px;
    }

    .image-wrapper {
      text-align: center;
      padding-top: 31px;
    }
  }

  .information-accordion {

    .expandable-question {
      font-size: 18px;
      line-height: 24px;

      ::v-deep .sections-label {
        padding: 35px 30px;
        .header-text {
          padding: 0 0 0 0;
        }
      }
      .answer {
        font-size: 18px;
        line-height: 24px;
        padding: 0 30px 35px;
        margin-top: -8px;
      }
    }
    .footer-info {
      padding: 36px 30px 12px;
      font-size: 16px;
      line-height: 22px;
      text-align: center;

      .word {
        display: inline-block;
      }
    }
  }

  .footer {
    background-color: $riseup_white;
    position: sticky;
    bottom: 0;
    display: flex;
    flex-direction: column;
    padding: 24px;
    text-align: center;

    .riseup-button {
      text-align: center;
      width: 100%;
      height: 75px;
    }
  }
}
</style>
